import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import Ajv from 'ajv'; // import betterAjvErrors from 'better-ajv-errors';

import { AssetType, OrderAction, ExpirationRules } from '@tradingblock/types';
import _ from 'lodash';
import dayjs from 'dayjs';
import { strikeValidation } from './strikeValidator';
import { validateSpreadRatio } from './spreadRatioValidation';
import { directionValidation } from './directionValidator';
export var SchemaValidator = function SchemaValidator(initial) {
  var ajv = initial || new Ajv({
    allErrors: true
  }); // options can be passed, e.g. {allErrors: true}

  ajv.addKeyword('strike', {
    type: 'array',
    compile: function compile(sch) {
      return strikeValidation(sch);
    },
    errors: true
  });
  ajv.addKeyword('action', {
    type: 'array',
    compile: function compile(sch) {
      return directionValidation(sch);
    },
    errors: true
  });
  ajv.addKeyword('ratio', {
    type: 'array',
    compile: function compile(sch) {
      return function validate(data) {
        var errors = validateSpreadRatio(sch)(data);

        if (errors !== null) {
          validate['errors'] = errors;
          return false;
        }

        return true;
      };
    },
    errors: true
  });
  ajv.addKeyword('expiration', {
    type: 'array',
    compile: function compile(sch) {
      return function validateExpiration(data) {
        if (_.get(validateExpiration, 'errors', null) === null) {
          validateExpiration['errors'] = [];
        }

        var legs = data;

        if (sch === ExpirationRules.SameExpiry) {
          var optionLegs = _.filter(legs, function (l) {
            return l && l.AssetType === AssetType.Option;
          });

          var expirations = _.filter(optionLegs, function (l) {
            return l.Expiration !== undefined && dayjs(l.Expiration.date) && dayjs(l.Expiration.date).isValid();
          }).map(function (l) {
            return dayjs(l.Expiration.date).format('YYYY/MM/DD');
          });

          if (_.uniq(expirations).length !== 1) {
            validateExpiration['errors'].push({
              keyword: 'expiration',
              message: "Leg Expirations must be the same. Values: [".concat(expirations.join(','), "]"),
              params: {
                expirations: expirations,
                rule: ExpirationRules[sch]
              }
            });
          }
        } else if (sch === ExpirationRules.DifferentExpiries) {
          var _optionLegs = _.filter(legs, function (l) {
            return l && l.AssetType === AssetType.Option;
          });

          var _expirations = _.filter(_optionLegs, function (l) {
            return l.Expiration !== undefined && dayjs(l.Expiration.date) && dayjs(l.Expiration.date).isValid();
          }).map(function (l) {
            return dayjs(l.Expiration.date).format('YYYY/MM/DD');
          });

          if (_.uniq(_expirations).length !== _optionLegs.length) {
            // if the root symbols are different, then we need to have the message read 'Expiration dates must differ.';
            // otherwise, we need to have the message read 'Expirations must differ.'
            var rootSymbols = _.uniq(_optionLegs.map(function (l) {
              return l.Expiration && l.Expiration.rootSymbol;
            }));

            var rootSymbol = rootSymbols.length === 1 ? rootSymbols[0] : undefined;
            var message = !rootSymbol ? "Expiration dates must differ." : "Expirations must differ.";
            validateExpiration['errors'].push({
              keyword: 'expiration',
              message: message,
              params: {
                expirations: _expirations,
                rule: ExpirationRules[sch]
              }
            });
          }
        } else if (sch === ExpirationRules.BuyWithLaterSellWithSooner) {
          var buyLeg = _.find(legs, function (l) {
            return l.AssetType === AssetType.Option && l.Action === OrderAction.Buy;
          });

          var sellLeg = _.find(legs, function (l) {
            return l.AssetType === AssetType.Option && l.Action === OrderAction.Sell;
          });

          var buyExpiration = buyLeg ? buyLeg.Expiration : undefined;
          var sellExpiration = sellLeg ? sellLeg.Expiration : undefined;

          if (!buyExpiration || !sellExpiration) {
            validateExpiration['errors'].push({
              keyword: 'expiration',
              message: "Order must have both buy and sell legs with valid expirations",
              params: {
                buyExpiration: buyExpiration,
                sellExpiration: sellExpiration,
                legs: legs
              }
            });
          } else if (!dayjs(buyLeg.Expiration.date).isAfter(sellLeg.Expiration.date)) {
            validateExpiration['errors'].push({
              keyword: 'expiration',
              message: "Buy leg expiration must be after sell leg expiration",
              params: {
                buyExpiration: buyExpiration,
                sellExpiration: sellExpiration,
                legs: legs
              }
            });
          }
        }

        return validateExpiration['errors'].length === 0;
      };
    },
    errors: true,
    metaSchema: {
      type: 'number'
    }
  });
  return ajv;
};
export var tryValidate = function tryValidate(ajv, schema, data) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var validate, validationRes, valid, errorMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            validate = ajv.compile(schema);
            validationRes = validate(data);

            if (!(typeof validationRes === 'boolean')) {
              _context.next = 6;
              break;
            }

            _context.t0 = validationRes;
            _context.next = 9;
            break;

          case 6:
            _context.next = 8;
            return validationRes;

          case 8:
            _context.t0 = _context.sent;

          case 9:
            valid = _context.t0;
            // var errorMessage = valid ? undefined : betterAjvErrors(schema, data, validate.errors);
            errorMessage = undefined;
            return _context.abrupt("return", {
              valid: valid,
              value: data,
              errors: validate.errors,
              errorMessage: errorMessage,
              reason: ajv.errorsText(validate.errors),
              ajv: validate
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};